import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./SearchCRUD";
import { searchSlice } from "./SearchSlice";

const { actions } = searchSlice;

export const callSearchList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  if (!queryParams) {
    dispatch(actions.searchListsFetch({ data: null }));
    return;
  }

  return requestToApi
    .checkSearchList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.searchListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkSearchList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const updateMemberVip = (queryParams) => (dispatch) => {

  return requestToApi
    .updateMemberVip(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          return response;
        }
      } else {
        throw new Error("Error api: updateMemberVip");
      }
    })
    .catch((error) => {
      throw error;
    });
};
export const callAgentList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkSearchList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.agentListsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkAgentList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
